import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=21cd8a88&"
import script from "./gift.js?vue&type=script&lang=js&"
export * from "./gift.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports